// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mobile-home-business-brochure-image[data-v-fa559244]{display:block;width:100%;max-width:600px;border-radius:16px;margin:16px auto 36px auto}@media(min-width:768px){.mobile-home-business-brochure-image[data-v-fa559244]{display:none}}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
